module.exports = __webpack_public_path__ + "img/2_hillstate.420a1597.png";